import dynamic from 'next/dynamic'

const Facebook = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ContentFacebook'),
)
const Email = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ContentEmail'),
)
const Twitter = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ContentTwitter'),
)
const Whatsapp = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ContentWhatsapp'),
)
const Pinterest = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ContentPinterest'),
)
import { styled, css } from '@thg-commerce/enterprise-theme'

interface BaseIconProps {
  colour: string
}

const BaseIcon = ({ colour }: BaseIconProps) => css`
  &:hover {
    > * {
      fill: ${colour};
    }
  }
`

export const StyledTwitterIcon = styled(Twitter)`
  ${(props) => BaseIcon({ colour: props.theme.colors.socialBrands.twitter })}
`

export const StyledFacebookIcon = styled(Facebook)`
  ${(props) => BaseIcon({ colour: props.theme.colors.socialBrands.facebook })}
`

export const StyledEmailIcon = styled(Email)`
  ${(props) => BaseIcon({ colour: props.theme.colors.palette.greys.dark })}
`

export const StyledWhatsAppIcon = styled(Whatsapp)`
  ${(props) => BaseIcon({ colour: props.theme.colors.socialBrands.whatsapp })}
`

export const StyledPinterestIcon = styled(Pinterest)`
  ${(props) => BaseIcon({ colour: props.theme.colors.socialBrands.pinterest })}
`
